import ProposalField from "work/proposals/proposal-fields/proposal-field";

/**
 * A closed side pane acknowledges the destination because navigation exposes its history immediately.
 * An already-open pane acknowledges the field being left, after the viewer had a chance to read it;
 * the newly selected field remains unread until it is left or deliberately opened another way.
 */
export function proposalFieldToMarkSeenOnTraversal(args: {
  sidePaneIsOpen: boolean;
  currentField?: ProposalField;
  destinationField: ProposalField;
}): ProposalField | undefined {
  return args.sidePaneIsOpen ? args.currentField : args.destinationField;
}
